"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableEnum = void 0;
var TableEnum;
(function (TableEnum) {
    TableEnum["Tables"] = "Tables";
})(TableEnum = exports.TableEnum || (exports.TableEnum = {}));
